import {
  useState, useCallback, useEffect, useContext
} from 'react';

import {
  getDigestionItemsForSubstituteHolidayStatus,
  downloadSubstituteHolidayCsv,
  getSubstituteDigestedtHistoryDetail,
} from 'api/holidayManagement';
import moment from 'moment';
import SubstituteHolidayStatusDomain from 'domain/master/holidayManagement/substituteHolidayStatus';
import useToastNotification from 'hooks/useToastNotification';
import { HolidayManagementContext } from './../HolidayManagementForm'

export interface DetailItems {
  staffCode: string,
  staffName: string,
  orgCode: string,
  orgName: string,
  grantDaysNum: string,
  digestedDaysNum: string,
  extinctionDaysNum: string,
  substituteDigestedtHistoryList: [],
  fromDate: Date,
  toDate: Date,
}


export const useHolidayManagementHolidayDomainForm = () => {
  const sessionStorageOrgCode = sessionStorage.getItem('loginUser.orgCode') || '';
  const [substituteHolidayStatusList, setSubstituteHolidayStatusList] = useState<Array<SubstituteHolidayStatusDomain>>([]);
  const [noManager, setNoManager] = useState(false);
  const [orgCode, setOrgCode] = useState(sessionStorageOrgCode);
  const [searchDate, setSearchDate] = useState<Date>(new Date());
  const [modalOpen, setModalOpen] = useState(false);
  const [detailItems, setDetailItems] = useState<DetailItems>({
    staffCode: '',
    staffName: '',
    orgCode: '',
    orgName: '',
    grantDaysNum: '',
    digestedDaysNum: '',
    extinctionDaysNum: '',
    substituteDigestedtHistoryList: [],
    fromDate: new Date(),
    toDate: new Date(),
  });
  const { errorNotification } = useToastNotification();

  const contextObject = useContext(HolidayManagementContext);

  // データの取得
  const fetchData = useCallback(async () => {
    contextObject.setIsLoading(true);
    const response = await getDigestionItemsForSubstituteHolidayStatus(
      orgCode !== 'all' ? orgCode : '',
      String(moment(moment(searchDate).toDate()).format('YYYY/MM/DD')),
    );
    contextObject.setIsLoading(false);
    setSubstituteHolidayStatusList(response.map((result) => new SubstituteHolidayStatusDomain(result)));
  }, [orgCode, searchDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData, noManager, orgCode, searchDate]);

  const toggleNoManager = useCallback(() => {
    setNoManager(!noManager);
  }, [noManager]);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  //
  const callGetSubstituteDigestedtHistoryDetail = useCallback(async (staffCode: string) => {
    try {
      await getSubstituteDigestedtHistoryDetail(
        staffCode,
        String(moment(moment(searchDate).toDate()).format('YYYY/MM/DD')),
      ).then((response: any) => {
        setDetailItems(response);
      });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        const listErr = error.response.data.errors;
        listErr.map((element: any) => errorNotification(element.defaultMessage));
      } else {
        errorNotification('サーバー側でエラーが発生しました。');
        throw error;
      }
    }
  }, [errorNotification, searchDate]);

  return {
    substituteHolidayStatusList,
    toggleNoManager,
    orgCode,
    setOrgCode,
    searchDate,
    setSearchDate,
    modalOpen,
    setModalOpen,
    closeModal,
    detailItems,
    setDetailItems,
    callGetSubstituteDigestedtHistoryDetail,
  };
};


export const useDownloadHolidayManagementHoliday = (
  orgCode: string,
  targetDate: Date,
) => {
  const [blocking, setBlocking] = useState(false);
  const downloadHolidayManagementHoliday = useCallback((isDownloadAll?: boolean) => {
    setBlocking(true);
    downloadSubstituteHolidayCsv(
      isDownloadAll ? '' : orgCode,
      targetDate,
    ).then(() => { 
      setBlocking(false);
    });
  }, [orgCode, targetDate]);

  return {
    blocking,
    downloadHolidayManagementHoliday,
  };
};

export default {
  useHolidayManagementHolidayDomainForm,
};
